import {Component, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {UserService} from '../../services/user/user.service';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {Router} from '@angular/router';
import {ReportsService} from '../../services/3080-reports/reports.service';
import AppConstants from '../../shared/common-components/AppConstants';
import {takeWhile} from 'rxjs/operators';

@Component({
    selector: 'app-survey-admin-report',
    templateUrl: './survey-admin-report.component.html',
    styleUrls: ['./survey-admin-report.component.css'],
    standalone: false
})
export class SurveyAdminReportComponent implements OnInit, OnDestroy {
  private observer$ = new BehaviorSubject(true);
  adminReports: any;
  adminReportsOptions: GridOptions = this.initializeGridOptions();
  private gridApi;
  columnDefs: any;
  public overlayNoRowsTemplate;
  rowData: any;
  showExport = false;
  years = [];
  currentYear: any = 0;
  excelStyles = [
    {
       id: 'textFormat',
       dataType: 'string',
     }
   ];

  constructor(private hhgrateService: HhgCarrierRateFilingService,
              private userService: UserService,
              private loader: LoadingService,
              private hhgService: HhgCarrierRateFilingService,
              private alertService: AlertService,
              private router: Router,
              private reportsService: ReportsService) {
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No results found. Please adjust your filters.</span>';

  }

  /**
   * initializing GridOptions
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      suppressAggFuncInHeader: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      rowData: this.adminReports,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  /**
   * initializing the ag-grid
   * @param: params
   */
  onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridApi.setGroupHeaderHeight(35);
    // this.gridApi.setHeaderHeight(40);
    this.gridApi.setGridOption('headerHeight', 40);
  }

  ngOnInit() {
    this.loader.show();
    this.loadingYears();
    // this.reportsService.getAdminReports().subscribe(data => {
    //   this.rowData = data;
    //   this.showExport = true;
    //   this.loader.hide();
    // }, error2 => {
    //   this.alertService.error('Error while getting admin reports');
    //   this.loader.hide();
    // });
    // this.updateColumnDefs(year);
  }

  loadingYears(){
    this.currentYear = new Date().getFullYear();
    this.years.push({name: this.currentYear, value: this.currentYear});
    for (let i = 1; i < 7; i++) {
      const previousYr = this.currentYear - i;
      this.years.push({name: previousYr, value: previousYr});
    }
    this.onYearChange(this.currentYear);
  }

  onYearChange(year) {
    this.loader.show();
    this.reportsService.getAdminReportsWithYear(year).pipe(takeWhile(() => this.observer$.value))
      .subscribe(reports => {
        console.log(reports);
        this.rowData = reports;
        this.showExport = true;
        this.loader.hide();
      }, error2 => {
        this.alertService.error('Error while getting admin reports');
        this.loader.hide();
      });
    this.updateColumnDefs(year);
  }

  /**
   * updating columns after result
   */
  updateColumnDefs(year) {
    this.columnDefs = this.getAdminReportsResultsColumnDefs(year);
  }

  getAdminReportsResultsColumnDefs(year): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
          {
            headerName: 'Evaluation Summary',
            children: [
              {
                header: '',
                children: [
                  {
                    headerName: 'Scac Code',
                    field: 'scacCode',
                    rowGroup: true,
                    hide: true,
                    valueGetter: function (params) {
                          if (params.data.scacCode){ return params.data.scacCode.toString();}
                      },
                    // keyCreator: this.scacKeyCreator
                  },
                  {
                    headerName: 'Survey #',
                    field: 'surveyNumber',
                    width: 180,
                    cellRenderer: params => {
                      if (params.data !== undefined && params.data !== null) {
                        return '<a tabindex="0">' + params.data.surveyNumber + '</a>';
                      }
                    },
                    onCellClicked: event => this.onSurveyNo(event.data)
                  },
                  {
                    headerName: 'SCAC Code',
                    filter: 'agTextColumnFilter',
                    width: 120,
                    field: 'scacCode'
                  },
                  {
                    headerName: 'FAIC Code',
                    field: 'faicCode',
                    width: 120,
                    filter: 'agTextColumnFilter',
                    cellClass: 'textFormat'
                  },
                  {
                    headerName: 'Agency Name',
                    field: 'agencyBureauName',
                    width: 120,
                    filter: 'agTextColumnFilter',
                    cellRenderer: params => {
                      if (AppConstants.isNotNullCondition(params.data) && AppConstants.isNotNullCondition(params.data.agencyBureauName)) {
                        return params.data.agencyBureauName.split('-')[0];
                      }
                    },
                  },
                  {
                    headerName: 'Bureau Name',
                    field: 'agencyBureauName',
                    width: 120,
                    filter: 'agTextColumnFilter',
                    cellRenderer: params => {
                      if (AppConstants.isNotNullCondition(params.data) && AppConstants.isNotNullCondition(params.data.agencyBureauName)) {
                        return params.data.agencyBureauName.split('-')[1];
                      }
                    },
                  },
                  {
                    headerName: 'Shipment Type',
                    filter: 'agTextColumnFilter',
                    field: 'shipmentType',
                    width: 120,
                    rowGroup: true
                  },
                  {
                    headerName: 'Employee Last Name',
                    filter: 'agTextColumnFilter',
                    width: 120,
                    field: 'employeeLastName'
                  },
                  {
                    headerName: 'Bill of Lading Number',
                    filter: 'agTextColumnFilter',
                    width: 120,
                    field: 'bolNumber'
                  },
                  {
                    headerName: 'Delivery Date',
                    filter: 'agTextColumnFilter',
                    width: 120,
                    field: 'deliveryDate'
                  }
                ]
              },
              {
                headerName: 'Employee Response',
                children: [
                  {
                    headerName: 'Total sum for Quality',
                    field: 'quality',
                    width: 100,
                    filter: 'agTextColumnFilter',
                    aggFunc: 'sum'
                  },
                  {
                    headerName: 'Avg Raw Score for Quality',
                    field: 'quality',
                    filter: 'agTextColumnFilter',
                    width: 100,
                    aggFunc: 'avg'
                  },
                  {
                    headerName: 'Total sum for Delivery',
                    field: 'delivery',
                    filter: 'agTextColumnFilter',
                    width: 100,
                    aggFunc: 'sum'
                  },
                  {
                    headerName: 'Avg Raw Score for Delivery',
                    field: 'delivery',
                    filter: 'agTextColumnFilter',
                    width: 100,
                    aggFunc: 'avg'
                  },
                  {
                    headerName: 'Total sum for Courtesy',
                    field: 'courtesy',
                    filter: 'agTextColumnFilter',
                    width: 100,
                    aggFunc: 'sum'
                  },
                  {
                    headerName: 'Avg Raw Score for Courtesy',
                    field: 'courtesy',
                    filter: 'agTextColumnFilter',
                    width: 100,
                    aggFunc: 'avg'
                  },
                  {
                    headerName: 'Total sum for Problems',
                    field: 'problems',
                    filter: 'agTextColumnFilter',
                    width: 100,
                    aggFunc: 'sum'
                  },
                  {
                    headerName: 'Avg Raw Score for Problems',
                    field: 'problems',
                    filter: 'agTextColumnFilter',
                    width: 100,
                    aggFunc: 'avg'
                  },
                  {
                    headerName: 'Total sum for Overall',
                    field: 'overall',
                    filter: 'agTextColumnFilter',
                    width: 100,
                    aggFunc: 'sum'
                  },
                  {
                    headerName: 'Avg Raw Score for Overall',
                    field: 'overall',
                    filter: 'agTextColumnFilter',
                    width: 100,
                    aggFunc: 'avg'
                  }
                ]
              },
              {
                headerName: 'General Remarks',
                children: [
                  {
                    headerName: 'Modified Score',
                    filter: 'agTextColumnFilter',
                    field: 'modifiedScore'
                  }
                ]
              }
            ]
          }
    ];

  }

  /**
   * Exporting the data in the csv format
   */
  // onBtnExport() {
  //   const date = new Date();
  //   const columnsForExport = [];
  //   const allColumns = this.adminReportsOptions.columnApi.getAllColumns();
  //   allColumns.forEach((element: any) => {
  //     if (element.colId !== 'scacCode') {
  //       columnsForExport.push(element.colId);
  //     }
  //   });
  //   const params = {
  //     fileName: 'hhg-admin-report-' + date,
  //     allColumns: columnsForExport,
  //     columnKeys: columnsForExport,
  //     columnGroups: true,
  //     columnSeparator: ','
  //   };
  //   this.gridApi.exportDataAsExcel(params);
  //   this.showExport = false;
  //   setTimeout(() => {
  //     this.showExport = true;
  //   }, 5200);
  // }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

  /**
   * setting row group
   * @param: params
   */
  scacKeyCreator(params) {
    if (AppConstants.isNotNullCondition(params)) {
      const countryObject = params.value;
      return countryObject.name;
    }
  }

  /**
   * setting row group value
   * @param: params
   */
  scacValueGetter(params) {
    if (AppConstants.isNotNullCondition(params)) {
      const scac = params.data.scacCode;
      const scacName = scac.substring(0, 2).toUpperCase();
      return {
        name: scac,
        code: scacName
      };
    }
  }

  /**
   * navigating to evaluation form
   * @param: data
   */
  onSurveyNo(data) {
    this.router.navigate(['/evaluationForm'],  { queryParams: { adminSurveyNo: data.surveyNumber } });
  }

}
